import React from 'react'
import SaveBtn from './saveBtn';
import { Link } from 'react-router-dom';
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";


export const CoinByCategoryTable = ({ data }) => {
    console.log(data[0])
    return (
        <table className="w-full min-w-max">
            <thead
                className="capitalize text-base text-white-100 
            font-medium border-b border-gray
            "
            >
                <tr className="text-sm lg:text-md">
                    <th className="py-1 text-left"> </th>
                    <th className="py-1 px-1 text-left">#</th>
                    <th className="py-1 px-1 text-left">name</th>
                    {/* <th className="py-1 px-1 text-left block lg:hidden"></th> */}
                    <th className="py-1 text-left">price</th>
                    <th className="py-1 text-left lg:table-cell hidden">total volume</th>
                    <th className="py-1 text-left lg:table-cell hidden">market cap</th>
                    <th className="py-1 text-left">24h %</th>
                    

                </tr>
            </thead>
            <tbody>
                {data.map((data, index) => {
                    return (
                        <tr
                            key={data.id}
                            className="text-center text-base border-b border-gray
            hover:bg-gray-200 last:border-b-0 text-sm lg:text-md
            "
                        >
                            <td><SaveBtn data={data} /></td>
                            <td className="py-4 flex items-center uppercase">

                                <span>
                                    <Link to={`/${data.id}`} className="cursor-pointer">
                                        <b><span>{data.market_cap_rank}</span></b>
                                    </Link>
                                </span>
                            </td>
                            <td className="py-4 item-center">

                                <Link to={`/${data.id}`} className="cursor-pointer">
                                    <span style={{ display: "flex" }}><img
                                        className="w-[1.5rem] h-[1.5rem] mx-1.5"
                                        src={data.image}
                                        alt={data.name}
                                    />
                                        <b><span className="hidden sm:inline">{data.name}</span> &nbsp; <span><b className="uppercase"> {data.symbol}</b></span></b>

                                    </span>
                                </Link>
                            </td>


                            <td className="py-4 flex item-center">
                                {/* <b>${new Intl.NumberFormat("en-IN", {
                                }).format(data.current_price)}</b> */}
                                {data.current_price > 1 ? <b>${data.current_price.toLocaleString()}</b> : <b>${data.current_price}</b> }
                            </td>

                            <td className="py-4 text-left lg:table-cell hidden"><b>${data.total_volume.toLocaleString()}</b></td>

                            <td className="py-4 flex item-center text-left lg:table-cell hidden">
                                <b>${data.market_cap.toLocaleString()}</b>
                            </td>

                            <td
                                className={
                                    data.price_change_percentage_24h > 0
                                        ? "text-left text-green py-4"
                                        : "text-left text-red py-4"
                                }
                            >
                                <span className="inline-flex items-center">
                                    {data.price_change_percentage_24h > 0 ? (
                                        <TiArrowSortedUp className="mr-1" />
                                    ) : (
                                        <TiArrowSortedDown className="mr-1" />
                                    )}
                                <b>{Number(
                                    data.price_change_percentage_24h
                                ).toFixed(2)}</b>%
                                </span>
                                
                            </td>
                          

                        </tr>
                    );
                })}
            </tbody>
        </table>
    )
}
